import { CloseIconSvg } from "@/design-system/icons/close-icon-slim";

export function CloseIconSlimButtonClassName({
    type = "button",
    title = "close",
    strokeWidth = 4,
    ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & { strokeWidth?: number }) {
    return (
        <button {...props} onClick={props.onClick} type={type} title={title}>
            {CloseIconSvg(strokeWidth)}
        </button>
    );
}
